"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractService = void 0;
const auth_header_1 = require("../services/auth_header");
class AbstractService {
    constructor(baseUrl, headerRetrievalFunction) {
        this.baseUrl = baseUrl;
        if (headerRetrievalFunction && typeof headerRetrievalFunction == 'function') {
            this.getHeaders = headerRetrievalFunction;
        }
        else {
            this.getHeaders = auth_header_1.getAuthHeader;
        }
    }
}
exports.AbstractService = AbstractService;
